import React from 'react';
import TDK from 'components/tdk';
import cn from 'classnames';
import Layout from 'components/layout';
import Contact from 'components/contact';
import style from 'styles/solution/telecommuting.module.scss';

const IMG_PATH = 'https://devcdn.xylink.com/xylink_website_doc/images/';
const IMG_PATH_NEW = 'https://testdevcdn.xylink.com/h5/sdk_doc/static/website/';
const features = [
  {
    icon: 'https://devcdn.xylink.com/xylink_website_doc/images/activity/telecommuting/pc/feat-icon-01.png',
    title: '即时开通 快速应用',
    desc: '快速注册开通账号，当天申请、当天使用\n覆盖全部员工',
  },
  {
    icon: 'https://devcdn.xylink.com/xylink_website_doc/images/activity/telecommuting/pc/feat-icon-02.png',
    title: '使用简便 不需培训',
    desc: '组会和参会操作流程简单\n普通用户不需培训即可操作使用',
  },
  {
    icon: 'https://devcdn.xylink.com/xylink_website_doc/images/activity/telecommuting/pc/feat-icon-03.png',
    title: '规模不限 覆盖全员',
    desc: '支持几十方至几千方的云会议室\n满足全员使用',
  },
  {
    icon: 'https://devcdn.xylink.com/xylink_website_doc/images/activity/telecommuting/pc/feat-icon-04.png',
    title: '不限网络 高清稳定',
    desc: '普通家庭宽带、3G/4G网络\n视频高清不卡顿',
  },
  {
    icon: 'https://devcdn.xylink.com/xylink_website_doc/images/activity/telecommuting/pc/feat-icon-05.png',
    title: '设备接入 多种类型',
    desc: '手机、PC、PAD，一体化视频终端\n会议室终端全覆盖',
  },
];
const Telecommuting = () => {
  return (
    <Layout layoutClass={style.layout} headerClass={style.header}>
      <TDK pageKey="telecommuting" />
      <div className={style.banner}>
        <img src={`${IMG_PATH}index/pc/telecommuting-banner-text.png`} alt="众志成城，应急防控" className={cn(style['title-text'], 'for-pc')} />
        <div className={cn(style['title-text'], 'for-mobile')}>
          <p>
            <span>众志成城</span>
            <span>应急防控</span>
          </p>
          <p>云视频助力远程办公</p>
        </div>
        <Contact className={style['contact-header']} />
      </div>
      <div className={style.free}>
        <div className={style.content}>
          <img src={`${IMG_PATH}activity/telecommuting/pc/quot.png`} className={style.quot} alt="" />
          <p className={style.word}>近期中央要求各企事业支持网上办公，减少人员聚集。假期后，各单位亟需一套让工作业务不停滞的远程办公协作系统。</p>
          <p className={style.word}>
            小鱼易连提供远程办公云视频方案：员工使用PC/Mac、手机，通过家庭宽带或4G网络就能实现多方高清会议，可共享电脑、手机中的Word、PPT、Excel等各种文档，会后还可生成音视频记录。
          </p>
        </div>
        <img src={`${IMG_PATH}activity/telecommuting/pc/free-img.png`} className={style.process} alt="" />
      </div>
      <div className={style.scene}>
        <p className={style.title}>功能和场景</p>
        <div className={style.content}>
          <div className={style['scene-item']}>
            <img className={cn('for-pc', style['scene-img'])} src={`${IMG_PATH_NEW}8080251e2411b41a5db97fe1eec7b19c148a0fc8481ab1ecf5e9cd1999ddba2f.jpg`} alt="" />
            <img className={cn('for-mobile', style['scene-img'])} src={`${IMG_PATH_NEW}f0ae7237cd4f2ba1dc1dec229d7533edf9c2e4cc7671d91ef1a0db486ece88e7.jpg`} alt="" />
            <p className={style.desc}>远程会议协作</p>
          </div>
          <div className={style['scene-item']}>
            <img className={cn('for-pc', style['scene-img'])} src={`${IMG_PATH}activity/telecommuting/pc/scene_02-pc.jpg`} alt="" />
            <img className={cn('for-mobile', style['scene-img'])} src={`${IMG_PATH}activity/telecommuting/m/scene_02-m.jpg`} alt="" />
            <p className={style.desc}>跨企业沟通</p>
          </div>
        </div>
      </div>
      <div className={style.features}>
        <p className={style.title}>小鱼易连云视频特点</p>
        <div className={style.content}>
          {features.map(item => {
            return (
              <div key={item.title} className={style['features-item']}>
                <img className={style['item-icon']} src={item.icon} alt="" />
                <div>
                  <div className={style['item-title']}>{item.title}</div>
                  <div className={style['item-desc']} dangerouslySetInnerHTML={{ __html: item.desc.replace(/\n/g, '<br/>') }}></div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className={style.case}>
        <p className={style.title}>客户案例</p>
        <div className={style.content}>
          {new Array(14).fill(IMG_PATH).map((item, index) => (
            <div key={index} className={style['img-wrap']}>
              <img src={`${item}activity/telecommuting/pc/logo-${index + 1 < 10 ? '0' + (index + 1) : index + 1}.png`} alt="" />
            </div>
          ))}
        </div>
      </div>
      <Contact className={style['contact-footer']} />
    </Layout>
  );
};

export default Telecommuting;
